import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import Swal from 'sweetalert2';
import * as moment from 'moment';

class createMitigation{
  description : string;
  calification : string;
  action_date : string;
  mitigation_deadline_date : string;
  users_id : number;
  risks_matrix_id : number;
  username : string;
}



@Component({
  selector: 'app-risk-mitigations-create',
  templateUrl: './risk-mitigations-create.component.html',
  styleUrls: ['./risk-mitigations-create.component.scss']
})
export class RiskMitigationsCreateComponent implements OnInit {

  idProject:number;
  idMatrix : number;

  mitigationCreateForm : FormGroup;

  listAssigned: any[] = [];
  listCalification : any[] = [];

  createMitigation : createMitigation;


  constructor(
    private apiService: ApiServiceProject,
    private router : Router,
    private activatedRoute : ActivatedRoute,
    private fb : FormBuilder,
    private spinner : NgxSpinnerService,
    private errorService:ErrorService
  ) { 
    this.activatedRoute.params.subscribe(params => {
      this.idProject = params ['id'];
      this.idMatrix = params ['idMatrix'];

    });


  }

  ngOnInit(): void {

  this.mitigationCreateForm = this.fb.group({
    description : [''],
    calification : [''],
    action_date : [''],
    mitigation_deadline_date : [''],
    users_id : [''],
    risks_matrix_id : [''],
    username : [''],
  });

  this.spinner.show();

  this.apiService.getService(`project-view-mitigations-option?id_project=${this.idProject}`)
  .subscribe({
    next : (data:any) =>{

      if (data.code == null) {
        if (data == '' || data == null) {
          this.spinner.hide();
          Swal.fire({
            title: 'No se encontraron registros',
            text: '',
            icon: 'info',
            confirmButtonText: 'Aceptar',
            heightAuto: false
          }).then((res) =>{
            if (res.isConfirmed || res.isDismissed) {
              this.router.navigate(['home']);
            }
          })
        }

        this.listAssigned = data.listAssigned;
        this.listCalification = data.listCalification ;

      this.spinner.hide();
      }else{
        this.spinner.hide();
        Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
      }
    },error:(error)=>{
      this.spinner.hide();
      Swal.fire({title:  error.error.message +'',text: '',icon: 'error',heightAuto: false});
    },
  });

  }

  formSubmit(): void {
    this.spinner.show();


    if (this.mitigationCreateForm.value.description === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una descripción',text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.mitigationCreateForm.value.users_id === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un responsable',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.mitigationCreateForm.value.calification === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una clasificacion',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.mitigationCreateForm.value.action_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una fecha de acción',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.mitigationCreateForm.value.mitigation_deadline_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una fecha limiite',text: '',icon: 'error',heightAuto: false});
      return;
    }

    this.createMitigation = new createMitigation();

    this.createMitigation.risks_matrix_id = Number(this.idMatrix);

      this.createMitigation.users_id = Number(this.mitigationCreateForm.value.users_id);
      this.createMitigation.action_date = moment(this.mitigationCreateForm.value.action_date).format("DD-MM-YYYY"); 
      this.createMitigation.mitigation_deadline_date = moment(this.mitigationCreateForm.value.mitigation_deadline_date).format("DD-MM-YYYY"); 
      this.createMitigation.description = this.mitigationCreateForm.value.description;
      this.createMitigation.calification = this.mitigationCreateForm.value.calification;

          this.apiService
          .postService('project-view-mitigations-create',this.createMitigation)
          .subscribe({
            next: (data:any)=>{
              if(data.message){
              this.spinner.hide();
              // this.listRisksMatrix = this.createRisk;
              Swal.fire({title: 'Se ha creado la mitigacion correctamente' ,text: '',icon: 'success',heightAuto: false})
              .then(( ) =>[this.router.navigate(['/pdg/project/',this.idProject, this.idMatrix ,'risk','mitigations'])] );
      
              }else{
                this.spinner.hide();
                Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false}).then((dato)=>{
                });
              }
            },
            error: (error) => {
              this.errorService.error(error);
            },
          });


  }

}
